<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
<app-loader></app-loader>
